module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-2-17e2d85d6fd992d1ccdf95498ae8cfec.jpg";